import { urlApiDiscussionExport } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { IBodyStartDiscussionExport, IDiscussionExportJobResponse } from '~/utils/interface/discussionExport';

// The export panel shows its own messages, so these calls skip the global error toast.
export const discussionExportApi = {
  startDiscussionExport(body: IBodyStartDiscussionExport) {
    const url = `${urlApiDiscussionExport.base}`;
    return axiosClient.post<IBaseResponse<IDiscussionExportJobResponse>>(url, body, { skipErrorToast: true });
  },

  getCurrentDiscussionExport() {
    const url = `${urlApiDiscussionExport.current}`;
    return axiosClient.get<IBaseResponse<IDiscussionExportJobResponse>>(url, { skipErrorToast: true });
  },

  downloadDiscussionExportFile(jobId: string) {
    const url = `${urlApiDiscussionExport.file(jobId)}`;
    return axiosClient.get<Blob>(url, { responseType: 'blob' });
  },
};
